import { Skeleton } from "antd";
import React, { useEffect, useRef, useState } from "react";

export type ICustomImageProps = React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>;

export const useImageLoaded = () => {
  const [loaded, setLoaded] = useState(false);
  const ref: any = useRef();

  const onLoad = () => {
    setLoaded(true);
  };

  useEffect(() => {
    if (ref.current && ref.current?.complete) {
      onLoad();
    }
  });
  return [ref, loaded, onLoad];
};

export default function CustomImage(props: ICustomImageProps) {
  const [ref, loaded, onLoad] = useImageLoaded();

  return (
    <React.Fragment>
      <img
        {...props}
        style={{
          opacity: loaded ? 1 : 0,
          position: loaded ? "relative" : "absolute",
          ...props.style,
        }}
        ref={ref}
        loading="lazy"
        onLoad={onLoad}
        alt={props.alt || "image"}
      />
      {!loaded && <Skeleton.Image></Skeleton.Image>}
    </React.Fragment>
  );
}
